module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (("transform:translate(" + (_vm.value.x) + "px, " + (_vm.value.y) + "px);")),
    attrs: {
      "data-x": _vm.value.x,
      "data-y": _vm.value.y
    }
  }, [_c('md-icon', {
    class: ("md-size-05x status" + (_vm.value.status))
  }, [_vm._v("camera_alt")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-007f1c33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StructureCameraIcon.vue
// module id = 820
// module chunks = 1